<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17ZM12 6C11.4532 6 11.0151 6.45294 11.0333 6.99944L11.2258 12.775C11.2393 13.1792 11.5709 13.5 11.9754 13.5H12.0246C12.4291 13.5 12.7607 13.1792 12.7742 12.775L12.9667 6.99944C12.9849 6.45294 12.5468 6 12 6Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
